import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { BehaviorSubject, concat, Observable, Subscription } from 'rxjs';
import { delay, tap } from 'rxjs/operators';
import { IMsgProviderService, MSG_PROVIDER_SERVICE } from '../../../interfaces';

@Component({
  selector: 'app-msg-collection-view',
  templateUrl: './msg-collection-view.component.html',
  styleUrls: ['./msg-collection-view.component.css']
})
export class MsgCollectionViewComponent implements OnDestroy, OnInit {

  resolvedFiles: { fileName: string, blob: Blob }[] = [];
  
  private _status = new BehaviorSubject(MsgCollectionViewComponentStatus.INITIAL);
  status$ = this._status.asObservable();

  private _resolveFilesSubscription: Subscription = null;
  private _subscriptions: Subscription[] = [];

  constructor(
    @Inject(MSG_PROVIDER_SERVICE) public msgProvider: IMsgProviderService
  ) { }

  ngOnDestroy(): void {
    for(let sub of this._subscriptions) sub.unsubscribe();
    this._subscriptions = [];
    if(this._resolveFilesSubscription) this._resolveFilesSubscription.unsubscribe();
  }

  ngOnInit(): void {
    this._subscriptions.push(...[
      this.msgProvider.msgFiles$.subscribe((files) => this.resolveFiles(files))
    ]);
  }

  resolveFiles(files: { blobProvider: () => Observable<Blob>, fileName: string }[]){
    this._status.next(MsgCollectionViewComponentStatus.INITIAL);
    this.resolvedFiles = [];
    if(this._resolveFilesSubscription) this._resolveFilesSubscription.unsubscribe();
    if(files.length === 0){
      this._status.next(MsgCollectionViewComponentStatus.READY);
      return;
    }
    this._status.next(MsgCollectionViewComponentStatus.RESOLVING);
    this._resolveFilesSubscription = concat(...files.map(x => x.blobProvider().pipe(
      delay(1000),
      tap((blob: Blob) => this.resolvedFiles.push({ fileName: x.fileName, blob: blob }))
    ))).subscribe({
      complete: () => this._status.next(MsgCollectionViewComponentStatus.READY)
    });
  }

}

export const MsgCollectionViewComponentStatus = {
  INITIAL: 0,
  RESOLVING: 1,
  READY: 2
}
